import React, { Component, PropTypes } from 'react'
import SelectField from 'material-ui/SelectField'
import MenuItem from 'material-ui/MenuItem'

import api from '../../api'

class SettingOptionSelector extends Component<any, any> {
  state = {
    options: null
  }

  componentWillMount () {
    api.get('v2/settings')
      .then(res => res.json())
      .then(settings => {
        this.setState({ options: settings[this.props.settingKey] })
      })
  }

  handleSelectChange = (event, index, value) => {
    this.props.onChange(event, value)
  }

  render () {
    const { options } = this.state

    if (options === null) {
      return <div />
    }

    return (
      <div>
        <SelectField
          floatingLabelText={this.props.label}
          value={this.props.value}
          onChange={this.handleSelectChange}
          errorText={this.props.errorText}
        >
          {this.props.nullable && <MenuItem value={null} primaryText='' />}
          {options.map(option => {
            return <MenuItem
              key={option.name}
              value={option.value}
              primaryText={option.name}
            />
          })}
        </SelectField>
      </div>
    )
  }
}

// @ts-ignore
SettingOptionSelector.propTypes = {
  settingKey: PropTypes.string,
  label: PropTypes.string.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  errorText: PropTypes.string,
  nullable: PropTypes.bool
}

// @ts-ignore
SettingOptionSelector.defaultProps = {
  value: null,
  errorText: null
}

export default SettingOptionSelector
